module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "product"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', [_c('h1', [_vm._v("大企业适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("核心端操作平台、woodpecker等产品将结合资金方案等供应链金融服务为您盘活企业现金流。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("核心端操作平台")]), _vm._v(" "), _c('p', [_vm._v("该平台实现供应链融资的全程电子化和全周期管理，核心企业可通过该平台使用群星提供的融资服务和引入的资金，同时通过平台优化信用管理体系及运营效率、提高资金使用率。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'core')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('div', {
    staticClass: "slider-box"
  }, [_c('div', {
    staticClass: "line"
  }, [(_vm.coreShow === 'platform') ? _c('div', {
    staticClass: "active"
  }) : (_vm.coreShow === 'tool') ? _c('div', {
    staticClass: "active",
    style: (_vm.coreShow === 'tool' ? 'top:47px;' : '')
  }) : (_vm.coreShow === 'product') ? _c('div', {
    staticClass: "active",
    style: (_vm.coreShow === 'product' ? 'top:94px;' : '')
  }) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', {
    style: (_vm.coreShow === 'platform' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'platform'
      }
    }
  }, [_vm._v("核心端操作平台")]), _vm._v(" "), _c('li', {
    style: (_vm.coreShow === 'tool' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'tool'
      }
    }
  }, [_vm._v("智能诊断工具")]), _vm._v(" "), _c('li', {
    style: (_vm.coreShow === 'product' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.coreShow = 'product'
      }
    }
  }, [_vm._v("数据风控产品")])])]), _vm._v(" "), _c('div', {
    staticClass: "right-img"
  }, [(_vm.coreShow === 'platform') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx1@2x.png",
      "alt": "img"
    }
  }) : (_vm.coreShow === 'tool') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx2@2x.png",
      "alt": "img"
    }
  }) : (_vm.coreShow === 'product') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/hx3@2x.png",
      "alt": "img"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("银行等金融机构适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("机构端操作平台、Shark等将结合数据分析供应链金融服务为您提供优质企业资源。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("数据风控产品")]), _vm._v(" "), _c('p', [_vm._v("数据风控产品有Viper、Shark，Shark是具有群星特色的行为评分卡，该模型通过捕捉企业的动态行为，可以得到不同等级的信用分数，从而量化风险。供应商和经销商可以通过Shark查看自己的风险级别。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'institution')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _c('div', {
    staticClass: "slider-box"
  }, [_c('div', {
    staticClass: "line",
    staticStyle: {
      "height": "95px"
    }
  }, [(_vm.institutionShow === 'product') ? _c('div', {
    staticClass: "active"
  }) : (_vm.institutionShow === 'platform') ? _c('div', {
    staticClass: "active",
    style: (_vm.institutionShow === 'platform' ? 'top:47px;' : '')
  }) : _vm._e()]), _vm._v(" "), _c('ul', [_c('li', {
    style: (_vm.institutionShow === 'product' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.institutionShow = 'product'
      }
    }
  }, [_vm._v("数据风控产品")]), _vm._v(" "), _c('li', {
    style: (_vm.institutionShow === 'platform' ? 'color:#000;' : ''),
    on: {
      "click": function($event) {
        _vm.institutionShow = 'platform'
      }
    }
  }, [_vm._v("机构端操作平台")])])]), _vm._v(" "), _c('div', {
    staticClass: "right-img"
  }, [(_vm.institutionShow === 'product') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg1@2x.png",
      "alt": "img"
    }
  }) : (_vm.institutionShow === 'platform') ? _c('img', {
    attrs: {
      "src": "/imgs/portal/products/jg2@2x.png",
      "alt": "img"
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('section', [_c('h1', [_vm._v("供应商/经销商适用的产品")]), _vm._v(" "), _c('h3', [_vm._v("核心端操作平台将结合链属营销等供应链金融服务为您解决资金难题。")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticStyle: {
      "margin-top": "85px"
    }
  }, [_vm._v("链属端操作平台")]), _vm._v(" "), _c('p', [_vm._v("链属端操作平台实现PC、APP、微信等多终端覆盖，同时优化用户体验，确保供应商和经销商随时随地完成货款结算，享受方便快捷的供应链金融服务。")]), _vm._v(" "), _c('div', {
    staticClass: "topage",
    on: {
      "click": function($event) {
        return _vm.topage('platform', 'chain')
      }
    }
  }, [_vm._v("进一步了解")]), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('portal-footer', {
    staticClass: "home-footer",
    attrs: {
      "page": "download-home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h2', [_vm._v("平台产品")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("了解群星的风控系统\n          "), _c('div', {
    staticClass: "showCompare"
  }, [_c('h1', [_vm._v("与传统风控方式相比，群星金融依托平台大数据风控模型，能更精准、智能地核定企业额度及账期；实时获取供应链中的每一笔数据，确保每一笔采购的真实性；贷款后也可以在线了解企业经营情况，达到监控的目的。")]), _vm._v(" "), _c('h2', [_c('span', [_vm._v("群星大数据风控")]), _vm._v("\n              VS\n              "), _c('strong', [_vm._v("传统风控方式")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-线上企业多维度信息的收集与整合，成本低、效率高")]), _vm._v(" "), _c('strong', [_vm._v("-传统线下繁复的企业调研，投入大、进展缓")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-除企业必要静态资料外，核心企业实时上传与链属企业的贸易流水信息，融资及还款数据，平台可给予企业相应的信用评级等")]), _vm._v(" "), _c('strong', [_vm._v("-仅在企业申请融资时能获得企业的静态资料，如企业财务报表、贸易合同等，部分保理商需支付高昂的成本获取第三方的信用报告")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-监控企业采购、应收账款生成、融资及回款资金的全过程")]), _vm._v(" "), _c('strong', [_vm._v("-不了解企业的真是经营情况，风险不透明、不可控")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', [_vm._v("-大数据挖掘分析模型、快速分析企业信用，合理推荐企业额度账期")]), _vm._v(" "), _c('strong', [_vm._v("-资料信息多，导致授信审批决策难、决策慢")])]), _vm._v(" "), _c('div', {
    staticClass: "contant"
  }, [_c('span', {
    staticStyle: {
      "border": "none",
      "border-right": "1px solid #d6d6d6"
    }
  }, [_vm._v("-贷后管理难，定期确认企业的还款意愿（如电话沟通，邮寄材料）")]), _vm._v(" "), _c('strong', {
    staticStyle: {
      "border": "none"
    }
  }, [_vm._v("-提供与企业实时沟通工具，贷款后也可以在线了解企业经营情况")])])])])]), _vm._v(" "), _c('h1', [_vm._v("群星金融拥有专业的产品开发团队，可以提供给供应链各方线上平台服务。")]), _vm._v(" "), _c('h1', [_vm._v("强大的数据风控能力并结合舒适的用户体验，")]), _vm._v(" "), _c('h1', [_vm._v("让您轻松完成简单快捷的线上操作。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": "/imgs/portal/products/ls1@2x.png",
      "alt": "img"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "process"
  }, [_c('h1', [_vm._v("供应链各方线上平台流程一览")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/imgs/portal/products/step@2x.png",
      "alt": "img"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-04dbf450"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/portal/components/products/Product.vue
// module id = 1250
// module chunks = 26